/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeagueStanding
 */
export interface LeagueStanding {
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof LeagueStanding
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueStanding
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueStanding
     */
    tag?: string;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    played: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    wins: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    draws: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    losses: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    goalsFor: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    goalsAgainst: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    goalDifference: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueStanding
     */
    points: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeagueStanding
     */
    form?: Array<string>;
}

/**
 * Check if a given object implements the LeagueStanding interface.
 */
export function instanceOfLeagueStanding(value: object): value is LeagueStanding {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('played' in value) || value['played'] === undefined) return false;
    if (!('wins' in value) || value['wins'] === undefined) return false;
    if (!('draws' in value) || value['draws'] === undefined) return false;
    if (!('losses' in value) || value['losses'] === undefined) return false;
    if (!('goalsFor' in value) || value['goalsFor'] === undefined) return false;
    if (!('goalsAgainst' in value) || value['goalsAgainst'] === undefined) return false;
    if (!('goalDifference' in value) || value['goalDifference'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function LeagueStandingFromJSON(json: any): LeagueStanding {
    return LeagueStandingFromJSONTyped(json, false);
}

export function LeagueStandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueStanding {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'teamId': json['teamId'],
        'teamName': json['teamName'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'played': json['played'],
        'wins': json['wins'],
        'draws': json['draws'],
        'losses': json['losses'],
        'goalsFor': json['goalsFor'],
        'goalsAgainst': json['goalsAgainst'],
        'goalDifference': json['goalDifference'],
        'points': json['points'],
        'form': json['form'] == null ? undefined : json['form'],
    };
}

export function LeagueStandingToJSON(json: any): LeagueStanding {
    return LeagueStandingToJSONTyped(json, false);
}

export function LeagueStandingToJSONTyped(value?: LeagueStanding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'tag': value['tag'],
        'played': value['played'],
        'wins': value['wins'],
        'draws': value['draws'],
        'losses': value['losses'],
        'goalsFor': value['goalsFor'],
        'goalsAgainst': value['goalsAgainst'],
        'goalDifference': value['goalDifference'],
        'points': value['points'],
        'form': value['form'],
    };
}

